<template>
	<div class="custom-multi-select">
		<el-popover
			ref="selectPopover"
			placement="bottom-start"
			title=""
			trigger="click"
			content=""
			popper-class="multi-select-dropdown"
			v-model="isPoperShow"
			@show="poperShow"
			transition="el-zoom-in-bottom"
		>
			<div
				slot="reference"
				:class="['select-section', { isSelected: isPoperShow }]"
				:style="{ width: width + 'px' }"
				@click.stop
			>
				<span v-show="!hasSelectedOptions" class="placeholder">{{ placeholder }}</span>
				<div v-show="hasSelectedOptions" class="selected-option">
					<div>
						{{ hasSelectedOptions ? selectedOptions[0][name] : ''
						}}{{ hasSelectedOptions && subTitle ? ' ' + selectedOptions[0][subTitle] : '' }}
					</div>
					<div class="num-box" v-show="selectedOptionsNoEmpty.length > 1">
						{{ '+' + moreLength }}
					</div>
				</div>
				<div :class="{ 'del-show': hasSelectedOptions, clearable: hasSelectedOptions && clearable }">
					<i class="el-icon-arrow-down"></i>
					<i class="iconfont ak-file-del" @click.stop="handelDeleteSelect"></i>
				</div>
			</div>
			<div class="multi-select-contain" :style="{ minWidth: width + 'px' }">
				<div class="custom-search-section">
					<el-input
						ref="searchInput"
						size="small"
						v-model="keywords"
						placeholder="搜索内容"
						@input="handleInput"
					></el-input>
				</div>
				<div class="checkbox-list">
					<el-checkbox
						v-if="showAllSelect"
						v-show="filterOptions.length > 0"
						v-model="checkAll"
						@change="handleCheckAllChange"
						>全选</el-checkbox
					>
					<div v-show="filterOptions.length === 0" class="notFind">无搜索结果</div>
					<el-checkbox-group v-model="checkedList" @change="handleCheckedChange">
						<el-checkbox v-for="(item, index) in filterOptions" :key="index" :label="item[value]">
							{{ item[name] }}
							<span v-if="subTitle" class="subTitle">{{ item[subTitle] }}</span>
						</el-checkbox>
					</el-checkbox-group>
				</div>
				<div v-if="!selectDirect" class="select-footer">
					<el-button type="default" size="mini" @click.stop="handleCancel">取消</el-button>
					<el-button type="primary" plain size="mini" @click.stop="handleConfirm">确定</el-button>
				</div>
			</div>
		</el-popover>
	</div>
</template>
<script>
export default {
	name: 'MultiSelect',
	props: {
		width: {
			type: [Number, String],
			default: 220,
		},
		placeholder: {
			type: String,
			default: '请选择',
		},
		options: {
			type: Array,
			default: () => {
				return []
			},
		},
		value: {
			type: String,
			default: 'value',
		},
		name: {
			type: String,
			default: 'name',
		},
		subTitle: {
			type: String,
			default: '',
		},
		selectedOptions: {
			type: Array,
			default: () => {
				return []
			},
		},
		showAllSelect: {
			type: Boolean,
			default: true,
		},
		selectDirect: {
			type: Boolean,
			default: false,
		},
		hide: {
			type: Boolean,
			default: false,
		},
		clearable: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		selectedOptionsNoEmpty() {
			if (!this.selectedOptions) {
				return []
			}
			return this.selectedOptions
		},
		hasSelectedOptions() {
			return this.selectedOptionsNoEmpty.length > 0
		},
		moreLength() {
			return this.selectedOptions.length - 1
		},
		filterOptions() {
			if (!this.options) {
				return []
			}
			return this.options.filter((item) => {
				if (item[this.name]) {
					return item[this.name].toUpperCase().indexOf(this.keywords.toUpperCase()) > -1
				} else if (item[this.subTitle]) {
					return item[this.subTitle].toUpperCase().indexOf(this.keywords.toUpperCase()) > -1
				} else if (item[this.value]) {
					return item[this.value].toUpperCase().indexOf(this.keywords.toUpperCase()) > -1
				}
			})
		},
	},
	watch: {
		hide(newVal) {
			if (newVal) this.isPoperShow = false
		},
	},
	data() {
		return {
			keywords: '',
			isPoperShow: false,
			checkAll: false,
			checkedList: [],
		}
	},
	methods: {
		poperShow() {
			this.$emit('hidePoper')
			let list = []
			this.selectedOptions.forEach((item) => {
				list.push(item[this.value])
			})
			this.checkedList = list
			this.checkAll = this.checkIsCheckedAll()

			this.$nextTick(() => {
				this.$refs['searchInput'].focus()
			})
		},
		handleCheckAllChange(val) {
			if (!val) {
				this.checkedList = []
				if (this.selectDirect) {
					this.changeSelectData()
				}
				return
			}
			let list = []
			this.filterOptions.forEach((item) => {
				list.push(item[this.value])
			})
			this.checkedList = list
			if (this.selectDirect) {
				this.changeSelectData()
			}
		},
		checkIsCheckedAll() {
			let isCheckedAll = true
			for (let item of this.filterOptions) {
				if (this.checkedList.findIndex((checkedItem) => item[this.value] === checkedItem) === -1) {
					isCheckedAll = false
					break
				}
			}
			return isCheckedAll
		},
		handleCheckedChange() {
			this.checkAll = this.checkIsCheckedAll()
			if (this.selectDirect) {
				this.changeSelectData()
			}
		},
		handleCancel() {
			this.isPoperShow = false
		},
		changeSelectData() {
			let options = this.options.filter(
				(item) => this.checkedList.findIndex((obj) => item[this.value] === obj) > -1
			)
			let selectedOptions = JSON.parse(JSON.stringify(options))
			this.$emit('update:selectedOptions', selectedOptions)
			this.$emit('change', selectedOptions)
		},
		handleConfirm() {
			this.changeSelectData()
			this.isPoperShow = false
		},
		handelDeleteSelect() {
			this.$emit('update:selectedOptions', [])
			this.$emit('change', [])
			this.isPoperShow = false
		},
		handleInput() {
			this.checkAll = this.checkIsCheckedAll()
		},
	},
}
</script>
<style lang="scss" scoped>
.select-section {
	height: 32px;
	box-sizing: border-box;
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 2px;
	cursor: pointer;
	outline: none;
	transition: all 0.3s;
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-left: 8px;
	padding-right: 8px;

	.placeholder {
		font-size: 12px;
		line-height: 12px;
		color: #aaa;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding-left: 0;
	}
	.selected-option {
		flex: 1;
		display: flex;
		font-size: 12px;
		line-height: 20px;
		color: #000;
		overflow: hidden;
		max-width: calc(100% - 28px);
		> div {
			padding: 0 4px;
			border-radius: 2px;
			background-color: #f5f5f5;
			max-width: 190px;
			min-width: 20px;
		}
		> div:first-child {
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.num-box {
			margin-left: 4px;
			flex-shrink: 0;
		}
	}
	i {
		transition: all 0.3s;
		font-size: 14px;
		color: #aaa;
	}
	.ak-file-del {
		display: none;
		cursor: pointer;
		font-size: 14px;
		width: 14px;
		height: 14px;
		line-height: 14px;
		border-radius: 50%;
		color: #ccc;
		&:hover {
			background: #888;
			color: white;
		}
	}
	&:hover {
		border-color: #aaa;
		.del-show {
			.el-icon-arrow-down {
				display: none;
			}
		}
		.clearable {
			.ak-file-del {
				display: block;
			}
		}
	}
	&.isSelected {
		border-color: #006eff !important;
		.el-icon-arrow-down {
			transform: rotate(180deg);
		}
	}
}
.multi-select-contain {
	.custom-search-section {
		padding: 4px 8px;
		/deep/ .el-input {
			font-size: 12px;
			.el-input__inner {
				border-top: none;
				border-left: none;
				border-right: none;
				border-radius: 0;
				border-color: #eee;
				padding: 0;
				&:focus,
				&:hover {
					border-color: #006eff;
				}
			}
		}
	}
	.checkbox-list {
		max-height: 274px;
		overflow-x: hidden;
		overflow-y: auto;
		.notFind {
			color: #bbb;
			justify-content: center;
			background-color: #fff;
			font-size: 12px;
			height: 32px;
			padding: 0 8px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			position: relative;
		}
		/deep/ .el-checkbox-group {
			display: flex;
			flex-flow: column;
		}
		/deep/ .el-checkbox {
			margin: 0;
			font-size: 12px;
			height: 32px;
			line-height: 32px;
			padding: 0 8px;
			box-sizing: border-box;
			// width: 100%;
			display: block;
			&:hover {
				background: #f9f9f9;
			}
			.el-checkbox__label {
				color: #333 !important;
				vertical-align: middle;
				font-size: 12px;
			}
			.el-checkbox__input.is-focus .el-checkbox__inner {
				border: 1px solid #ccc;
			}
			.el-checkbox__input.is-checked .el-checkbox__inner {
				border: 1px solid #006eff;;
			}
		}
		.subTitle {
			color: rgb(187, 187, 187);
			margin-left: 5px;
		}
	}
	.select-footer {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		height: 40px;
		padding-right: 8px;
		.el-button + .el-button {
			margin-left: 8px;
		}
	}
}
</style>
